<template>
  <div>
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>设置</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select
        style="margin-left: 20px; width: 140px"
        size="mini"
        v-model="SelectStoresID"
        @change="changedian()"
        placeholder="门店"
         v-if="DianList.length>1"
      >
        <el-option
          v-for="item in DianList"
          :key="item.ID"
          :label="item.StoresName"
          :value="item.ID"
        >
        </el-option>
      </el-select>
    </div>

    <div style="width：100%;padding-top:50px">
      <div  style="width:100%;display:flex;flex-wrap:wrap">
        <div class="box flex-xy" style="margin-left:1%" v-if="q1 == true" @click="handleThailand()">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-office-building" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">门店管理</div>
                <div class="describe___1xZnj">可对门店基本信息进行编辑</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>
                
            </div>
        
          </div>
          <!-- <div class="flex-xy" style="width: 95%; height: 75%">
            <div class="num" style="margin-top: -10px">0</div>
          </div> -->
        </div>
        <div class="box flex-xy"  style="margin-left:1%" v-if="q2 == true" @click="handleRole()">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-user" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">角色管理</div>
                <div class="describe___1xZnj">可对角色权限进行配置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>
                
            </div>
        
          </div>

        </div>
        <div class="box flex-xy" style="margin-left:1%" v-if="q3 == true" @click="handleOperator()">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-user-solid" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">

                <div class="boxTitle">操作员</div>
                <div class="describe___1xZnj">可对操作员信息进行管理</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>

            </div>
        
          </div>
          <!-- <div class="flex-xy" style="width: 95%; height: 75%">
            <div class="num" style="margin-top: -10px">0</div>
          </div> -->
        </div>
        <div class="box flex-xy" @click="handlePaySetting()" v-if="q4 == true && IsPay == 1 && isProject == 1" style="margin-left:1%">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
            <img src="../../assets/icon/pay.png" alt="" srcset="" style="width:20px;height:20px">
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">支付配置</div>
                <div class="describe___1xZnj">可对支付信息进行配置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>
                
            </div>
        
          </div>
          <!-- <div class="flex-xy" style="width: 95%; height: 75%">
            <div class="num" style="margin-top: -10px">0</div>
          </div> -->
        </div>
        <div class="box flex-xy" style="margin-left:1%"  v-if="q5 == true && isProject == 1"   @click="handleOverallSetting()">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-setting" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">基础配置</div>
                <div class="describe___1xZnj">可对平台基础功能进行配置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>
                
            </div>
        
          </div>
          <!-- <div class="flex-xy" style="width: 95%; height: 75%">
            <div class="num" style="margin-top: -10px">0</div>
          </div> -->
        </div>
        <div class="box flex-xy" style="margin-left:1%"  v-if="q6 == true && isProject == 1" @click="handleSetting()" >
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-document" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">预约设置</div>
                <div class="describe___1xZnj">可对预约功能的相关条件进行设置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>
                
            </div>
        
          </div>
          <!-- <div class="flex-xy" style="width: 95%; height: 75%">
            <div class="num" style="margin-top: -10px">0</div>
          </div> -->
        </div>
        <!-- <div class="box flex-xy" style="margin-left:1%" v-if="IsHeadOffice==1 && q7 == true && isProject == 1"  @click="handleSMSSetting()"> -->
       <div class="box flex-xy" style="margin-left:1%" v-if="IsHeadOffice==1 && q7 == true  "  @click="handleSMSSetting()">

          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-chat-dot-round" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">消息模板</div>
                <div class="describe___1xZnj">可对平台的推送消息进行配置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>
                
            </div>
        
          </div>

        </div>

        <div class="box flex-xy" style="margin-left:1%"  v-if="q9 == true && isProject == 1 && IsCD == 1"  @click="handlesite()">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-setting" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">{{WZCDName}}设置</div>
                <div class="describe___1xZnj">可对场地信息进行配置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>    
            </div>
          </div>
        </div>
        <!-- <div class="box flex-xy"   @click="handlePhone()"  v-if="q10 == true && isProject == 1" style="margin-left:1%"> -->
      <div class="box flex-xy"   @click="handlePhone()"  v-if="q10 == true " style="margin-left:1%">

          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-mobile" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">手机端设置</div>
                <div class="describe___1xZnj">可对小程序首页进行页面布局排班</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>    
            </div>
          </div>
        </div>
        <div class="box flex-xy"   @click="handlePhoto()"   style="margin-left:1%">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-picture-outline" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">照片墙设置</div>
                <div class="describe___1xZnj">可对小程序照片进行图片管理</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>    
            </div>
          </div>
        </div>
        <div class="box flex-xy"   @click="handleIntergral()"  v-if="isjifen == 1" style="margin-left:1%">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-star-off" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">积分设置</div>
                <div class="describe___1xZnj">可对会员积分进行管理</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>    
            </div>
          </div>
        </div>
        <div class="box flex-xy" style="margin-left:1%"  v-if="iscdyy == 1"  @click="handlesite1()">
          <div class="flexc-cen-x" style="width: 95%;height:70%">
            <div style="height:100%">
                <i class="el-icon-setting" style="font-size:20px"></i>
            </div>
            <div  style="height:100%;margin-left:20px">
                <div class="boxTitle">{{WZCDName}}设置</div>
                <div class="describe___1xZnj">可对场地信息进行配置</div>
                <div><el-button type="text" size="mini"><span style="font-size:12px">查看设置</span></el-button></div>    
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      DianList: [],
      SelectStoresID: localStorage.getItem("StoresID"),
      IsHeadOffice: localStorage.getItem("IsHeadOffice"),
      isProject:localStorage.getItem('isProject'),
      isjifen:localStorage.getItem('isjifen'),
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
        IsPay:localStorage.getItem("IsPay"),
        hyIsPay:localStorage.getItem("hyIsPay"),
        spIsPay:localStorage.getItem("spIsPay"),
        gkIsPay:localStorage.getItem("gkIsPay"),
        hdIsPay:localStorage.getItem("hdIsPay"),
        xmIsPay:localStorage.getItem("xmIsPay"),
        IsCD:localStorage.getItem("IsCD"),
      iscdyy:localStorage.getItem("iscdyy"),

       WZCDName:localStorage.getItem("WZCDName"),
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      q9:false,
      q10:false,
      q11:false,
      q12:false,
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    };
  },
  // 注册组件
  components: {
    Pagination,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
        if(localStorage.getItem('isAdmin') == 1){  

          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
          this.q9 = true
          this.q10 = true
          this.q11 = true
          this.q12 = true

      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 132)
            this.q1  =true
            if(items == 133)
            this.q2 = true
            if(items == 134)
            this.q3 = true
            if(items == 135)
            this.q4 = true
            if(items == 136)
            this.q5 = true
            if(items == 137)
            this.q6 = true
            if(items == 138)
            this.q7 = true
            if(items == 139)
            this.q8 = true
            if(items == 1311)
            this.q9 = true
            if(items == 1312)
            this.q10 = true
            if(items == 1313)
            this.q11 = true
          
      
      })
    this.getDianList();
    // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
    handlePhone(){
      this.$router.push({
        path:`/phoneSetting/phoneSetting/${this.SelectStoresID}`
      })
    },
    handlePhoto(){
      this.$router.push({
        path:`/photo/photo/${this.SelectStoresID}`
      })
    },
    tosetting(){
         this.$router.push({ path: '/setting/setting'})
    },
    changedian() {
      this.getDianList();
    },
    getDianList() {
      var data = {
        SelectStoresID: localStorage.getItem("StoresID"),
        token: localStorage.getItem("token"),
        StoresID: localStorage.getItem("StoresID"),
      };
      var that = this;
      this.ajax(
        "getListStores.aspx",
        JSON.stringify(data),
        "POST",
        function (res) {
          if (res.orsuccess == "1") {
            that.DianList = res.data;
          }
        }
      );
    },
    handleIntergral(){
        this.$router.push({
           path: `/setting/integral/${this.SelectStoresID}`,
      });
    },
    handlesite(){
       this.$router.push({
        path: `/arrange/site/${this.SelectStoresID}`,
      });
    },
    handlesite1(){
       this.$router.push({
        path: `/setting/SiteSetting/${this.SelectStoresID}`,
      });
    },
    
    handlePersonnel(){
      this.$router.push({
        path: `/personnel/personnel/${this.SelectStoresID}`,
      });
    },
    // 
    handleRole(){
      this.$router.push({
        path: `/operator/role/${this.SelectStoresID}`,
      });
    },
    handleOperator(){
      this.$router.push({
        path: `/operator/operator/${this.SelectStoresID}`,
      });
    },
    
    // /operator/role/:id
    handleThailand(){
       this.$router.push({
        path: `/Thailand/Thailand/${this.SelectStoresID}`,
      });
    },
    handleSetting() {
      this.$router.push({
        path: `/setting/SettingInfo/${this.SelectStoresID}`,
      });
    },
    handleOverallSetting() {
      this.$router.push({
        path: `/setting/OverallSettingInfo/${this.SelectStoresID}`,
      });
    },
    handlePaySetting() {
      this.$router.push({
        path: `/setting/PaySettingInfo/${this.SelectStoresID}`,
      });
    },
    handleSMSSetting() {
      this.$router.push({
        path: `/setting/SMSSettingInfo/${this.SelectStoresID}`,
      });
    },
    handleTextSetting() {
      this.$router.push({
        path: `/setting/TextSettingInfo/${this.SelectStoresID}`,
      });
    },
  },
};
</script>
<style scoped>
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .describe___1xZnj {
    margin-top: 8px;
    font-size: 12px;
    color: rgb(102, 102, 102);
    line-height: 30px;
}
.boxTitle{
  font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgb(25, 25, 25);
    /* line-height: 22px; */
}
.box {
  cursor: pointer;
  width: 24%;
  height: 130px;

  box-sizing: border-box;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ececec;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
}
</style>


// WEBPACK FOOTER //
// src/views/setting/setting.vue